export const NAV_BU_LOCAL_STORAGE_KEY = 'SELECTED_BUSINESS_UNIT';

export const HAS_DISMISSED_BANNER_USER_SETTING_KEY =
  'HAS_DISMISSED_BU_DEPRECATION_BANNER';
export const HAS_SEEN_BANNER_USER_SETTING_KEY =
  'HAS_SEEN_BU_DEPRECATION_BANNER';
